import axiosInstance from './axios';

// Cliente del parqueadero (para facturación)
export interface ParkingClient {
    id: string;
    tipoDocumento: string;
    numeroDocumento: string;
    nombre: string;
    email?: string;
    telefono?: string;
    direccion?: string;
    ciudad?: string;
    ciudadId?: string;
}

export interface CreateClientData {
    tipoDocumento: string;
    numeroDocumento: string;
    nombre: string;
    email?: string;
    telefono?: string;
    direccion?: string;
    ciudad?: string;
    ciudadId?: string;
}

/**
 * Buscar cliente por número de documento
 */
export const searchClientByDocument = async (documento: string): Promise<ParkingClient | null> => {
    const response = await axiosInstance.get<ParkingClient | null>(`/clients/search?documento=${documento}`);
    return response.data;
};

/**
 * Buscar clientes por término (nombre o documento)
 */
export const searchClients = async (term: string): Promise<ParkingClient[]> => {
    const response = await axiosInstance.get<ParkingClient[]>(`/clients?term=${term}`);
    return response.data;
};

/**
 * Obtener todos los clientes
 */
export const getAllClients = async (): Promise<ParkingClient[]> => {
    const response = await axiosInstance.get<ParkingClient[]>('/clients');
    return response.data;
};

/**
 * Crear nuevo cliente
 */
export const createClient = async (data: CreateClientData): Promise<ParkingClient> => {
    const response = await axiosInstance.post<ParkingClient>('/clients', data);
    return response.data;
};
